/**
 * GoldFire Network (https://goldfire.me)
 * Copyright (c) 2012 - 2020, GoldFire Studios, Inc.
 * http://goldfirestudios.com
 */

import Vue from 'vue';
import VTooltip from 'v-tooltip';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import 'core-js';
import './awayCheck';
import {app, router, store} from './client-create-app';

// Setup tooltips support.
Vue.use(VTooltip);

// Setup the Sentry.io integration.
Raven
  .config('https://29afae2b426f452986b0706f4d904504@sentry.io/166937')
  .addPlugin(RavenVue, Vue)
  .install();

// Setup Stripe connection.
if (typeof window !== 'undefined' && !window.navigator.userAgent.match(/CasinoRPG-Mobile|Exocraft-Mobile/)) {
  const stripeScript = document.createElement('script');
  stripeScript.type = 'text/javascript';
  stripeScript.src = 'https://js.stripe.com/v2/';
  document.body.appendChild(stripeScript);
  stripeScript.onload = () => {
    const isProd = (process.env.NODE_ENV === 'production' && process.env.TEST_ENV !== 'true');
    Stripe.setPublishableKey(isProd ? 'pk_l9mGyI8QRm1ixl95d0ux1dyyG2XY5' : 'pk_MKooN4vSllf0NTLx84FtbA6K2eggZ');
  };
}

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__);
}

// Mount the app to the DOM.
router.onReady(() => {
  app.$mount('#app');
});
